import { defineStore } from 'pinia'
import _ from 'lodash';
import type { AxiosResponse } from 'axios';
import axios, { AxiosError, isAxiosError } from 'axios';
import type { Company } from "@/types/Company.ts";

interface CompaniesResponse {
  data: Company[];
}

interface CompaniesState {
  companies: Company[]|null;
  companiesInterval: boolean;
  loading: boolean;
}

export const useCompaniesStore = defineStore('companies', {
  state: (): CompaniesState => ({
    companies: null,
    companiesInterval: false,
    loading: false,
  }),
  actions: {
    async _fetchCompanies(): Promise<void> {
      if (this.loading) return;
      this.loading = true;
      //      if (!this.companiesInterval) {
      //        this.companiesInterval = setInterval(() => this.fetchCompanies(), 300000);
      //      }
      try {
        const response: AxiosResponse<CompaniesResponse> = await axios.get('/api/smart/companies');
        this.companies = response.data.data;
      } catch(error) {
        console.log("MIG- Companies Not possible");
      } finally {
        this.loading = false;
      }
    },
    fetchCompanies(): void {
      const throttle = _.throttle(async () => { await this._fetchCompanies(); }, 10000);
      void throttle();
    },
    loadCompanies() {
      if (this.companies) return;
      this.fetchCompanies();
    }
  },
});
